import dayjs from 'dayjs'
import CategoriesProvider from '@/resources/CategoriesProvider'
import TicketProvider from '@/resources/TicketProvider'

const CategoriesService = new CategoriesProvider()
const TicketService = new TicketProvider()

/** Keep prior UI display format (Buddhist calendar when dayjs buddhistEra is loaded). */
const PREVIEW_FMT = 'DD MMMM BBBB HH:mm:ss'

/**
 * Category priority + business-hours due preview (API SLALogic).
 *
 * @param {object} opts
 * @param {number|string} opts.categoryId
 * @param {number|string|null|undefined} opts.groupId - agent user group (required for due calc)
 * @param {number|string|null|undefined} [opts.ticketId] - when set, due is from ticket.createdAt
 * @returns {Promise<{ priority: *, dueDate: *|null, dueDateDisplay: string }>}
 */
export async function loadCategorySlaPreview ({ categoryId, groupId, ticketId }) {
  const { data } = await CategoriesService.findOne(categoryId)
  if (!data) {
    return { priority: null, dueDate: null, dueDateDisplay: '' }
  }

  let dueDate = null
  if (groupId != null && groupId !== '') {
    const query = {
      groupId,
      categoryId
    }
    if (ticketId) {
      query.ticketId = ticketId
    }
    const sla = await TicketService.calculateSla(query, { skipLoading: true })
    dueDate = sla?.data?.dueDate ?? null
  }

  return {
    priority: data.priority,
    dueDate,
    dueDateDisplay: dueDate ? dayjs(dueDate).format(PREVIEW_FMT) : ''
  }
}
